import { render, staticRenderFns } from "./CommentListItem.vue?vue&type=template&id=64d2664a&scoped=true&"
import script from "./CommentListItem.vue?vue&type=script&lang=js&"
export * from "./CommentListItem.vue?vue&type=script&lang=js&"
import style0 from "./CommentListItem.vue?vue&type=style&index=0&id=64d2664a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d2664a",
  null
  
)

export default component.exports